import { request } from '@/lib/api'

/**
 * Риск клиента (тикет #135): правило с весами, причины словами сервера.
 *
 * Поля ответа сравниваются нестрого (`== null`): сервер не кладёт пустые поля в JSON вовсе.
 */

export type RiskLevel = 'high' | 'medium' | 'low'

export type RiskReasonCode = 'silent' | 'complaints' | 'overdue' | 'late_history' | 'revenue_drop' | 'due_soon'

export interface RiskReason {
  code: RiskReasonCode
  weight: number
  /** Причина словами — собрана сервером из фактов, экран её не пересказывает. */
  text: string
}

export interface ClientRiskView {
  counterpartyId: string
  counterpartyName: string
  inn?: string | null
  responsibleEmployeeId?: string | null
  responsibleName?: string | null
  score: number
  level: RiskLevel
  reasons?: RiskReason[]
  /** Когда клиент вошёл в зону риска; нет — он не в ней. */
  riskSince?: string | null
  computedAt: string
  /** О входе в риск сказали ответственному. */
  announced: boolean
  /** Уведомление кто-то получил (false — у клиента нет ответственного с учётной записью). */
  anyoneTold: boolean
}

/** Пороги правила — с сервера, а не своей копией. */
export interface RiskRule {
  high: number
  highExit: number
  medium: number
  silenceDays: number
  minUnanswered: number
  complaintDays: number
  dueSoonDays: number
}

export interface ClientRiskList {
  clients: ClientRiskView[]
  truncated: boolean
  rule: RiskRule
}

export interface CounterpartyRisk {
  risk?: ClientRiskView | null
  rule: RiskRule
}

export type LevelFilter = 'all' | 'high' | 'medium'

export function fetchClientRisk(level: LevelFilter, signal?: AbortSignal): Promise<ClientRiskList> {
  return request<ClientRiskList>(`/sales/client-risk?level=${level}`, { signal })
}

export function fetchCounterpartyRisk(counterpartyId: string, signal?: AbortSignal): Promise<CounterpartyRisk> {
  return request<CounterpartyRisk>(`/sales/counterparties/${counterpartyId}/risk`, { signal })
}
